module.exports = __webpack_public_path__ + "img/register.9e173124.svg";